import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

const Card: React.FC<BoxProps> = ({ children, ...rest }) => {
  return (
    <Box
      bg="white"
      boxShadow="0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%)"
      padding={8}
      borderRadius={2}
      maxW="650px"
      margin="auto"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
